import React from "react";

/**
 * Renders a page component with additional props.
 * Kept for call-site compatibility after the React Router v6 migration.
 */
export default function AddRouteComponentProp({
  component: Component,
  additionalProps = {},
}) {
  return <Component {...additionalProps} />;
}
